






































































import Vue, { PropType } from "vue"
import { UPLOAD_ICON, LINK_ICON, DESCRIPTION_ICON } from "~/config/icon"
import SectionTitle from "~/components/guideline/util/SectionTitle.vue"
import RowGroup from "~/components/guideline/util/RowGroup.vue"
import ColumnWithIcon from "~/components/guideline/util/ColumnWithIcon.vue"
import EditItemDescription from "~/components/guideline/util/EditItemDescription.vue"
import { OneOutput } from "~/backendApis/viewModel"
import { OutputOGP } from "~/backendApis/viewModel/common"
import PRichOGPCard from "~/components/custom/ogp/PRichOGPCard.vue"

export default Vue.extend({
  components: {
    SectionTitle,
    RowGroup,
    ColumnWithIcon,
    EditItemDescription,
    PRichOGPCard,
  },
  props: {
    portfolios: {
      type: Array as PropType<OneOutput[]>,
      required: true,
    },
    outputOgps: {
      type: Array as PropType<OutputOGP[]>,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icon: {
        upload: UPLOAD_ICON,
        link: LINK_ICON,
        description: DESCRIPTION_ICON,
      },
      descriptionText: `積極的にプロジェクトに参画したい方は、アップロードしていただくとマッチング率が向上します。デザイン・クリエイティブ関連は、プロジェクト応募時に必要な場合があります。`,
    }
  },
  computed: {
    editLinkForSectionTitle(): string {
      if (!this.isEditable) {
        return ""
      }
      return "/profiles/edit/portfolio"
    },
  },
  methods: {
    getOutputOGP(siteURL: string): OutputOGP | null {
      return this.outputOgps.find((ogp) => ogp.siteURL === siteURL) || null
    },
    isImageURL(url: string): boolean {
      // サーバー側で許容している拡張子のうち、画像を示すもの。
      const imageExtension = [
        "PNG",
        "png",
        "GIF",
        "gif",
        "JPG",
        "jpg",
        "JPEG",
        "jpeg",
      ]
      return imageExtension.some((extension) => url.endsWith(`.${extension}`))
    },
  },
})
